'use strict';

(function () {

    angular.module('zp').factory('DatepickerModel', datepickerModelFactory);

    function datepickerModelFactory() {
        function DatepickerModel() {
            this.show = false;
            this.display = '';
            this.dateFormat = 'MMMM dd, yyyy';
            this.options = {
                dateDisabled: false,
                formatYear: 'yy',
                maxDate: new Date(2020, 5, 22),
                minDate: new Date(),
                startingDay: 1,
                showWeeks: false,
                showButtonBar: false
            };
        }

        return DatepickerModel;
    }
})();